import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import { LuPenLine } from 'react-icons/lu';
import { TbDatabaseEdit } from 'react-icons/tb';

// ★ 追加: CSS Modules をインポート
import styles from './styles.module.css';

export const Footer: React.FC = () => {
  const location = useLocation();
  const isGenActive =
    location.pathname === '/' || location.pathname === '/result';
  const isHistoryActive = location.pathname === '/history';

  return (
    // ★ 修正: styles オブジェクトを使用
    <footer className={styles.footerContainer}>
      {/* mobile-links クラスは不要になった（スタイルファイル内で管理） */}
      {/* <div className="footer-button left"> */}
      <div className={styles.footerButton}>
        <Link
          to="/"
          // ★ 修正: styles オブジェクトを使用し、条件付きクラス名を適用
          className={`${styles.footerLink} ${isGenActive ? styles.footerLinkActive : ''}`}
        >
          <LuPenLine
            className={`${styles.footerIcon} ${isGenActive ? styles.footerIconActive : ''}`}
          />
          文書生成
        </Link>
      </div>
      <div className={styles.footerDivider} />
      {/* <div className="footer-button center"> */}
      <div className={styles.footerButton}>
        <Link
          to="/history"
          className={`${styles.footerLink} ${isHistoryActive ? styles.footerLinkActive : ''}`}
        >
          <TbDatabaseEdit
            className={`${styles.footerIcon} ${isHistoryActive ? styles.footerIconActive : ''}`}
          />
          作成履歴
        </Link>
      </div>
      {/* Footer link to settings might be removed */}
      {/* <div className="footer-divider" />
            <div className="footer-button right"> ... </div> */}
    </footer>
  );
};
